import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { FirmaCalificacionPage } from './firma-calificacion.page';
import { IonicRatingModule } from 'ionic4-rating';
import { SignaturePadModule } from 'angular2-signaturepad';




const routes: Routes = [
  {
    path: '',
    component: FirmaCalificacionPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SignaturePadModule,
    IonicRatingModule,
    RouterModule.forChild(routes)
  ],
  declarations: [FirmaCalificacionPage]
})
export class FirmaCalificacionPageModule {}
